import { devicesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("device"),
  endpoint: "devices",
  operations: devicesOps,
  roleView: [ROLE.USER_VIEW, ROLE.USER_ADMIN],
  roleAdmin: [ROLE.USER_ADMIN],
  singularName: (t) => t("Device"),
  name: (t) => t("Devices"),
});

export default conf;
